import React  from "react";
import ChatBox from "../../../Whatsapp/elements/WhatsappChatBox";


const WhatsAppChatBox = ({  open, id, leadDetails,setChatBoxOpen,AssignTo }) => {

  return (
    <>
  
      <ChatBox openFrmDetail={open} id={id} phone_number={leadDetails?.phone_number} Name={leadDetails?.name} closeFromDetail={setChatBoxOpen} />
    </>
  );
};

export default WhatsAppChatBox;
